import React, { Component } from 'react';
import BotonContinuar from '../components/BotonContinuar';
import InputFecha from '../components/InputFecha';
import { calcular_edad, celularCorrecto, dniCorrecto, fechaCorrecta } from '../components/Utilitario';
import '../css/pages/PasoInicio.css';
import * as utils from '../FxUtils';
import PoliticaPrivacidadCheckbox from '../components/PoliticaPrivacidadCheckbox';
import EmailAutocomplete from '../components/EmailAutocomplete';
import ReCAPTCHA from "react-google-recaptcha";
import BenefitsAccount from '../components/BenefitsAccount';
import DivInformacion from '../components/DivInformacion';
import Header from '../components/Header';
import TextFieldBbva from '../basics/TextFieldBbva';
import { getInicio, postGuardarDatosBasicos, getObtenerFlagCorreo } from '../services';
import BannerInicioPromo from '../components/BannerInicioPromo';

import {
  llenarDataLayer,
  setEntornoTagueo,
  TAG_PANT_CUENTAS,
  TAG_PANT_INICIO,
  setOperationNumber,
  setEstadoCliente,
  setNumCelular,
  setCorreo,
  BTN_EMPEZAR,
  TAG_CONTINUAR,
  TAG_PANT_INICIO_EVENTO_CLICK,
  setCodigoCuenta,
  setNombreCuenta,
} from '../tagueo/CuentasDatalayer';
import styled from "styled-components";
import Loading from '../components/Loading';
import Footer from '../components/Footer';

const ID_NUMDOC = 'txtNumeroDni';
const ID_NUMCELULAR = 'txtCelular';
const ID_FECNAC = 'txtFechaNacimiento';
const ID_CORREO = 'txtCorreo';
const ID_CHBOX_TDP = 'chbTratamientoDatosPersonales';

class PasoInicio extends Component {


  constructor(props) {
    super(props);
    this.store = this.props.store;

    this.contexto = this.props.contexto;
    this.contexAjax = this.props.contexAjax;

    this.state = {
      dni: '',
      errorDni: '',
      celular: '',
      correo: '',
      errorCelular: '',
      errorCorreo: '',
      codigoCaptcha: '',
      keyCaptcha: '6Lc42gIqAAAAAB8tl3MMwGtlDTFO5oyATgi3d_uh',
      fechaNacimiento: '',
      errorFechaNacimiento: '',
      bloqueoFinalizar: '',
      procesando: true,
      responseInit: {},
      showReply: false,
      dataTagueo: '',
      renderRecaptcha: '',
      load: false,
      valorTyC: false,
      tituloBanner: '',
      textoBanner: '',
      urlImagenBanner: '',
      textoLinkBanner: '',
      tituloBannerSecundario: '',
      textoBannerSecundario: '',
      urlTdp: '',
      isCuentaDigitalActive: '',
      HAS_EMAIL : false,
      cuentas: {},
      codigoCuentaPredeterminada: '',
      labelCuentaPredeterminada: '',
      disclaimerGanadora:'',
      codigoCuentaSeleccionadaPaso1: '',
      labelCuentaSeleccionadaPaso1: '',
      footer: [],
    };
    this._reCaptchaRef = React.createRef();
  }


  onChangeFechNacimiento = (e) => {
    let valorfecha = e.target.value.trim();
    if (valorfecha.length <= 10 || valorfecha.length === 0) {
      this.setState({ fechaNacimiento: valorfecha });
      if (valorfecha.length > 0 && (!this.state.errorFechaNacimiento || valorfecha.length === 10)) {
        let flagValidation = this.state.HAS_EMAIL ?
          (celularCorrecto(this.state.celular) && dniCorrecto(this.state.dni) && this.state.correo):
          (celularCorrecto(this.state.celular) && dniCorrecto(this.state.dni))
        ;

        if (flagValidation) {
          this.setState({ procesando: fechaCorrecta(valorfecha) ? false : true });
        }
      } else {
        this.setState({ procesando: true });
      }
    }
  };

  validarFechaNacimiento = (valorfecha) => {
    let valido = false;
    if (valorfecha.trim().length > 0) {
      valido = this.validaFormatoFechaNacimiento(valorfecha);
    } else if (valorfecha === '') {
      this.setState({ errorFechaNacimiento: MENSAJES_ERROR.ERROR_FECHA_VACIO });
      valido = false;
    } else {
      this.setState({
        errorFechaNacimiento: MENSAJES_ERROR.ERROR_FECHA_NACIMIENTO,
      });
      valido = false;
    }
    return valido;
  };

  onBlurFechaNacimiento = (e) => {
    this.validarFechaNacimiento(this.state.fechaNacimiento);
  };

  onChangeDni = ({target}) => {
    let valorDni = target.value.trim();
    if (valorDni.length <= 8 && (utils.validaSoloNumeros(valorDni) || valorDni.length === 0)) {
      this.setState({ dni: valorDni });
      if (valorDni.length > 0 && (!this.state.errorDni || valorDni.length === 8)) {
        let flagValidation = this.state.HAS_EMAIL ?
          (fechaCorrecta(this.state.fechaNacimiento) && celularCorrecto(this.state.celular) && this.state.correo):
          (fechaCorrecta(this.state.fechaNacimiento) && celularCorrecto(this.state.celular));

        if (flagValidation) {
          this.setState({ procesando: dniCorrecto(valorDni) ? false : true });
        }
      } else {
        this.setState({ procesando: true });
      }
    }
  };

  onBlurDni = (ex) => {
    this.validarDni(this.state.dni);
  };

  validarDni = (valorDni) => {
    let valido = false;
    if (valorDni.trim().length > 0 && utils.validaFormatoDni(valorDni)) {
      this.setState({ errorDni: MENSAJES_ERROR.SIN_ERROR });
      valido = true;
    } else if (valorDni === '') {
      this.setState({ errorDni: MENSAJES_ERROR.ERROR_DNI_VACIO });
      valido = false;
    } else {
      this.setState({ errorDni: MENSAJES_ERROR.ERROR_DNI_NO_VALIDO });
      valido = false;
    }
    return valido;
  };

  onChangeCelular = (e) => {

    let valorCelular = e.target.value.trim();

    if (!this.state.HAS_EMAIL) {

      if (valorCelular.trim().length <= 9) {

        if (!utils.validaSoloNumeros(valorCelular) && valorCelular.length > 0) { return ; }
        this.setState({ celular: valorCelular });

        let flagValidation = fechaCorrecta(this.state.fechaNacimiento) && dniCorrecto(this.state.dni);

        if(flagValidation) {
          this.setState({ procesando: celularCorrecto(valorCelular) ? false : true });
        }

      }

    }
    else {

      if ((valorCelular.length <= 9 && utils.validaSoloNumeros(valorCelular)) || valorCelular.length === 0) {
        this.setState({ celular: valorCelular });

        if (valorCelular.length > 0 && (!this.state.errorCelular || valorCelular.length === 9)) {
          let flagValidation = this.state.HAS_EMAIL ?
            (this.state.fechaNacimiento && this.state.dni && this.state.correo):
            (this.state.fechaNacimiento && this.state.dni)
          ;

          if (flagValidation) {
            this.setState({ procesando: false });
          }
        } else {
          this.setState({ procesando: true });
        }
      }

    }

  };

  onBlurCelular = (e) => {
    this.validarCelular(this.state.celular);
  };

  validarCelular = (valorCelular) => {
    let valido = false;
    if (valorCelular.trim().length > 0 && utils.validaCelular(valorCelular)) {
      this.setState({ errorCelular: MENSAJES_ERROR.SIN_ERROR });
      valido = true;
    } else if (valorCelular === '') {
      this.setState({ errorCelular: MENSAJES_ERROR.ERROR_CELULAR_VACIO });
      valido = false;
    } else {
      this.setState({ errorCelular: MENSAJES_ERROR.ERROR_CELULAR_NO_VALIDO });
      valido = false;
    }
    return valido;
  };

  validaFormatoFechaNacimiento(valorFecha) {
    if (fechaCorrecta(valorFecha)) {
      let mayorEdad = calcular_edad(valorFecha) >= VALIDACION_DATA.EDAD_MINIMA;
      this.setState({
        errorFechaNacimiento: mayorEdad ? MENSAJES_ERROR.SIN_ERROR : MENSAJES_ERROR.ERROR_FECHA_MENOR_DE_EDAD,
      });
      return mayorEdad;
    } else {
      this.setState({
        errorFechaNacimiento: MENSAJES_ERROR.ERROR_FECHA_NACIMIENTO,
      });
      return false;
    }
  }

  onChangeCorreo(e) {
    let valorCorreo = e.target.value.trim();
    this.setState({ correo: valorCorreo });
  }

  onBlurCorreo(e) {
 
  }

 //Mostrar email por flag correo
  mostrarEmail = async() => {
    try {
      const email= await getObtenerFlagCorreo(this.props.contexAjax)
      .then(res=>res.vars.flagActivarCorreo)
      this.setState({ HAS_EMAIL: email });
    } catch (error) {
      console.info("no se obtuvo flag correo",error);
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    let urlInicio = this.contexAjax + 'inicio';
    let parametroAppBancaMovil = window.location.search.indexOf('app=');

    if (parametroAppBancaMovil > 0) {
      urlInicio = urlInicio + '?app=BMOVILWB';
    }
    this.cuentasInicio(urlInicio);

    this.mostrarEmail();

  }

  cuentasInicio = (urlInicio) => {
    window.addEventListener('load', this.handleLoad);
    getInicio(urlInicio)
      .then((res) => {
        const tipoCuentas = this.getCmbTipoCuentas(res.vars.tipoCuentas); 
        const codigoCuentaPredeterminada = tipoCuentas ? tipoCuentas[0].value : '';
        const labelCuentaPredeterminada = tipoCuentas ? tipoCuentas[0].label : '';
        this.setState({
          responseInit: res,
          dataTagueo: res.vars.tagueoVisita,
          keyCaptcha: res.vars.keyCaptcha,
          urlImagenBanner: res.vars.imagenBanner,
          tituloBanner: res.vars.tituloBanner,
          textoBanner: res.vars.textoBanner,
          textoLinkBanner: res.vars.textoLinkBanner,
          tituloBannerSecundario: res.vars.tituloBannerSecundario,
          textoBannerSecundario: res.vars.textoBannerSecundario,
          urlTdp: res.vars.urlTdp,
          isCuentaDigitalActive: res.vars.cuentaDigitalBbva === '0' ? false : true,
          cuentas: tipoCuentas,
          codigoCuentaPredeterminada: codigoCuentaPredeterminada,
          labelCuentaPredeterminada: labelCuentaPredeterminada,
          codigoCuentaSeleccionadaPaso1: codigoCuentaPredeterminada,
          labelCuentaSeleccionadaPaso1: labelCuentaPredeterminada,
          footer: res.vars.footer
        });
        setEntornoTagueo(res.vars.ambTag);
        this.store.dispatch({
          type: 'DATA_FOR_TAGUEO',
          data: this.state.dataTagueo,
        });
        this.store.dispatch({ type: 'CUENTA_DIGITAL_ACTIVE', data: this.state.isCuentaDigitalActive });
        this.store.dispatch({ type: 'FOOTER_DATA', data: this.state.footer });

      })
      .catch((error) => {
        this.props.history.replace(this.contexto + 'error');
      });
  };

  handleLoad = () => {
    llenarDataLayer(TAG_PANT_INICIO, '');
  };

  onClickTagueo = (e) => {
    if (!this.state.renderRecaptcha) {
      this.setState({ renderRecaptcha: true });
    }
    const { id } = e.target;
    let tagueo = {
      [ID_NUMDOC]: 'numero dni',
      [ID_FECNAC]: 'fecha nacimiento',
      [ID_NUMCELULAR]: 'numero celular',
      [ID_CORREO]: 'email',
      [ID_CHBOX_TDP]: 'checkbox politica de privacidad'
    };
    llenarDataLayer(TAG_PANT_INICIO_EVENTO_CLICK, tagueo[id]);
  };

  tagueoPantallaCuentas = () => {
    llenarDataLayer(TAG_PANT_CUENTAS, '');
  };

  validarDatos = () => {
    let dni = this.state.dni;
    let celular = this.state.celular;
    let fechaNacimiento = this.state.fechaNacimiento;
    let validaDatos = false;
    let validaDni = false;
    let validaCelular = false;
    let validaFechaNacimiento = false;

    this.setState({
      errorCorreo: MENSAJES_ERROR.SIN_ERROR,
      errorCelular: MENSAJES_ERROR.SIN_ERROR,
      errorDni: MENSAJES_ERROR.SIN_ERROR,
      errorFechaNacimiento: MENSAJES_ERROR.SIN_ERROR,
    });

    validaDni = this.validarDni(dni) ? true : false;

    validaCelular = this.validarCelular(celular) ? true : false;

    validaFechaNacimiento = this.validarFechaNacimiento(fechaNacimiento) ? true : false;

    if (validaCelular && validaDni && validaFechaNacimiento) {
      validaDatos = true;
    }

    return validaDatos;
  };

  handleChange = value => {
    let token = '';
    this.setState( {tokenCaptcha: value});
    token = this.state.tokenCaptcha;
    this.logica(token);
  };

  getDatos = () => {
    if(!this.state.isCuentaDigitalActive) {
      llenarDataLayer(TAG_PANT_INICIO_EVENTO_CLICK, 'empieza ahora');
    }
    let datosValidos = this.validarDatos();
    let valido = true;
    if (datosValidos && valido) {
          if(this.state.keyCaptcha === "-1"){
            let token = 'O_O';
            this.logica(token);
          }else {
            try {
              this._reCaptchaRef.current.execute();
              setTimeout(() => {
                if (this.state.codigoCaptcha === '') {
                  valido = false;
                  this.setState({
                    procesando: false,
                    showReply: false,
                  });
                }
              }, 1500);
            }  catch (error) {
                console.info("error en recaptcha",error);
                let token = 'O_O';
                this.logica(token);

            }

          }
    }
    else
    {
     if (this._reCaptchaRef && this._reCaptchaRef.current) { 
          this._reCaptchaRef.current.reset();
          console.log("quitando el objeto recaptcha en getdatos");
        }
      this.setState({ procesando: false,showReply: false,});
    }
  };

  logica(token) {
    if (token === null || token === '' && !this.state.keyCaptcha === "-1") {
      return false;
    }
    llenarDataLayer(TAG_CONTINUAR, BTN_EMPEZAR);
    this.setState({
      procesando: true,
      showReply: true,
    });
        postGuardarDatosBasicos(this.contexAjax, {
          tagueoVisita: this.state.dataTagueo,
          numeroDocumento: this.state.dni,
          telefono: this.state.celular,
          codigoCaptcha: token,
          fechaNacimiento: this.state.fechaNacimiento,
          correo: this.state.correo,
          flagTdp: this.state.valorTyC,
          digitalData: JSON.stringify(window.digitalData),
        })
        .then((res) => {
          if (res.vars.listaCuentas !== undefined) {
            let dataForSelectAccount = {};
            dataForSelectAccount.tagueoVisita = this.state.dataTagueo;
            dataForSelectAccount.montoDolares = res.vars.montoDolares;
            dataForSelectAccount.montoSoles = res.vars.montoSoles;
            dataForSelectAccount.openMarket = res.vars.openMarket;
            dataForSelectAccount.cuentaVip = res.vars.cuentaVip;
            dataForSelectAccount.listaCuentas = res.vars.listaCuentas;
            dataForSelectAccount.pdfComparativo = res.vars.pdfComparativo;
            dataForSelectAccount.esClienteNuevo = res.vars.openMarket;            
            dataForSelectAccount.codigoCuentaSeleccionadaPaso1 = this.state.codigoCuentaSeleccionadaPaso1;
            dataForSelectAccount.labelCuentaSeleccionadaPaso1 = this.state.labelCuentaSeleccionadaPaso1;
            setOperationNumber(res.vars.idOperation);
            setEstadoCliente(dataForSelectAccount.openMarket);
            setNumCelular(this.state.celular);
            setCorreo(this.state.correo);
            setCodigoCuenta(dataForSelectAccount.codigoCuentaSeleccionadaPaso1);
            setNombreCuenta(dataForSelectAccount.labelCuentaSeleccionadaPaso1);
            this.tagueoPantallaCuentas();
            this.store.dispatch({
              type: 'DATA_FOR_SELECT_ACCOUNT',
              data: dataForSelectAccount,
            });
            this.store.dispatch({ type: 'MOSTRAR_DIRECCION', data: res.vars.mostrarDireccion });
            this.store.dispatch({ type: 'NOMBRE_USUARIO', data: res.vars.nombres || '' });
            this.store.dispatch({ type: 'DATA_EMAIL', data: this.state.correo });
            this.store.dispatch({ type: 'CUENTA_CELULAR', data: this.state.celular });
            this.store.dispatch({ type: 'DATOS_BANNER', data: this.getDatosBanner() });
            this.props.history.replace(this.contexto + 'pasoEleccionCuenta');
          } else {
           
            if (res.vars.idOperation != null) {
              setOperationNumber(res.vars.idOperation);
            }
            let paginaError = res.vars.errorUrl;

            if (paginaError !== "" && paginaError !== undefined && this._reCaptchaRef && this._reCaptchaRef.current)
            {
                 this._reCaptchaRef.current.reset();
                 console.log("quitando el objeto recaptcha por paginaError");
            }

            switch(paginaError) {
              case "error-reniec-noexiste":

                this.setState({
                  errorDni: MENSAJES_ERROR.ERROR_DNI_NO_EXISTE,
                  showReply: false,
                  procesando: false,
                });
                break;
              case "error-antifraude-celular":
                this.setState({
                  errorCelular: MENSAJES_ERROR.ERROR_CELULAR_ANTIFRAUDE,
                  showReply: false,
                  procesando: false,
                });
                break;
              case "error-antifraude-correo":

                this.setState({
                  errorCorreo: MENSAJES_ERROR.ERROR_CORREO_ANTIFRAUDE,
                  showReply: false,
                  procesando: false,
                });
                break;
              case  "error-fec-nacimiento":

                this.setState({
                  errorFechaNacimiento: MENSAJES_ERROR.ERROR_FECHA_INCORRECTA,
                  showReply: false,
                  procesando: false,
                });
                break;

              default:
                this.store.dispatch({ type: 'NOMBRE_USUARIO', data: res.vars.nombres || '' });
                this.store.dispatch({ type: 'ERROR', data: paginaError });
                this.props.history.replace(`${this.contexto}error`);
            }
          }
        })
        .catch((error) => {
          this.props.history.replace(this.contexto + 'error');
          console.log("error", error);
        });
  }
  getCheck = (value) => {
    return value === 'green' ? '✓' : '';
  };

  actualizarCorreo = (e) => {
    if(e) {
      let valorCorreo = e.target.value.trim();
      if(this.state.celular && this.state.dni && this.state.fechaNacimiento){
        this.setState({
          ...this.state,
          correo: valorCorreo,
          procesando: false,
          errorCorreo: ''
        });
      } else{
        this.setState({
          ...this.state,
          correo: valorCorreo,
          procesando: true,
          errorCorreo: ''
        });
      }
    }else{
      this.setState({
        ...this.state,
        correo: null,
        procesando: true,
        errorCorreo: ''
      });
    }
  };

  actualizarPolitica = (e) => {
    this.setState({...this.state, valorTyC: e});
  };

  onClickTagueoModal(){
    llenarDataLayer(TAG_PANT_INICIO_EVENTO_CLICK, 'pdf politica de privacidad');
  }

  keyPress(e) {}

  getCmbTipoCuentas = (tipoCuentas) => {
    const tiposCuenta = tipoCuentas ? tipoCuentas.map(item => {
      const { codigo, descripcion } = item;  
      return {
        label: descripcion,
        value: codigo
      };
    }) : [];
    return tiposCuenta;
  }

  getDatosBanner = () => {
    return {
      tituloBanner: this.state.tituloBanner,
      textoBanner: this.state.textoBanner,
      urlImagenBanner: this.state.urlImagenBanner,
      textoLinkBanner: this.state.textoLinkBanner,
      tituloBannerSecundario: this.state.tituloBannerSecundario,
      textoBannerSecundario: this.state.textoBannerSecundario
    };
  };

  callBackPrincipal = (disclaimer,valueCuenta,labelCuenta) => {
    this.setState(
      {...this.state, 
      disclaimerGanadora: disclaimer,
      codigoCuentaSeleccionadaPaso1:valueCuenta,
      labelCuentaSeleccionadaPaso1: labelCuenta
    });
    llenarDataLayer(TAG_PANT_INICIO_EVENTO_CLICK, 'cuenta');
  }

  render() {

    return (
      <div className='md:w-0.8 m-auto px-6 md:px-0 pb-4'>
        <Header perfilHeader='PERSONAL' />
        <div className='paso-inicio__div-principal'>
          <BannerInicioPromo
            titulo={this.state.tituloBanner}
            descripcion={this.state.textoBanner}
            link={this.state.textoLinkBanner}
            logo={this.state.urlImagenBanner}
          />
          <div className='hidden md:block'>
            <DivInformacion
              titulo={this.state.tituloBannerSecundario}
              descripcion={this.state.textoBannerSecundario}
            />
          </div>          
          <section className='paso-inicio__div-contenido'>
            <div className='flex flex-col gap-8 w-full'>
              <div className='paso-inicio__div-formulario'>
                <div className="paso-inicio__div-completar-datos">
                  <div className="item-container-datos-inicio">
                    <TextFieldBbva
                      disablePaste
                      id={ID_NUMDOC}
                      error={this.state.errorDni}
                      label={'Número de DNI'}
                      onChange={this.onChangeDni}
                      onBlur={this.onBlurDni}
                      onClickProp={this.onClickTagueo}
                      value={this.state.dni}   
                      inputmode={'tel'}  
                      cssColorBackGround={true}
                    />
                    <InputFecha
                      className="item-fechaNacimiento"
                      id={ID_FECNAC}
                      label={'Fecha de nacimiento'}
                      value={this.state.fechaNacimiento}
                      onChange={this.onChangeFechNacimiento}
                      onBlur={this.onBlurFechaNacimiento}
                      disablePaste
                      error={this.state.errorFechaNacimiento}
                      mensajeDisclaimer={'Ejemplo: dd/mm/aaaa'}
                      typeInput={'date'}
                      onClickProp={this.onClickTagueo}
                      cssColorBackGround={true}
                    />
                    <TextFieldBbva
                      id={ID_NUMCELULAR}
                      error={this.state.errorCelular}
                      label={'Número de celular'}
                      onChange={this.onChangeCelular}
                      onBlur={this.onBlurCelular}
                      onClickProp={this.onClickTagueo}
                      disablePaste 
                      value={this.state.celular}
                      inputMode="tel"
                      cssColorBackGround={true}                      
                    />
                    {this.state.HAS_EMAIL &&
                    <EmailAutocomplete
                      id={ID_CORREO}
                      updateEmailValue={this.actualizarCorreo}
                      onClickProp={this.onClickTagueo}
                      errorCorreoMessage={this.state.errorCorreo}
                    />
                    }
                  </div>
                </div>
                <div className="paso-inicio__div-tdp">
                  <PoliticaPrivacidadCheckbox
                    id={ID_CHBOX_TDP} 
                    urlModal={this.state.urlTdp}
                    updateCheckedValue={this.actualizarPolitica}
                    onClickModal={this.onClickTagueoModal}  
                    onClickTagueoCheck={this.onClickTagueo}
                    css={"checkbox_wrapper__persona"}
                  />
                </div>
                {this.state.showReply && <Loading mensaje={'Espera un momento, estamos procesando la información'} />}

                {this.state.keyCaptcha !== "-1" &&
                <DivCaptcha visibility="none">
                  <ReCAPTCHA
                      style={{ display: "inline-block" }}
                      theme="dark"
                      size="invisible"
                      ref={this._reCaptchaRef}
                      sitekey={this.state.keyCaptcha}
                      onChange={this.handleChange}
                  />
                </DivCaptcha>}
              </div>
              {this.state.disclaimerGanadora}
              <div className='content-button'>
                <BotonContinuar onClick={this.getDatos} disabled={this.state.procesando}>Empezar</BotonContinuar>
              </div>
            </div>
            <div className='block md:hidden'>
              <DivInformacion
                descripcion={this.state.textoBannerSecundario}
              />
            </div>            
            <div className='paso-inicio__div-beneficios'>
              <BenefitsAccount 
                cuentas={this.state.cuentas} 
                codigoCuentaPredeterminada={this.state.codigoCuentaPredeterminada}
                labelCuentaPredeterminada={this.state.labelCuentaPredeterminada}
                callBackPrincipal={this.callBackPrincipal}
              />
            </div>
          </section>
          <Footer cmbFooter={this.state.footer}></Footer>   
        </div>
      </div>
    );
  }
}

const MENSAJES_ERROR = {
  SIN_ERROR: '',
  ERROR_CELULAR_NO_VALIDO: 'Es necesario que ingreses un número de celular válido.',
  ERROR_CELULAR_VACIO: 'Es necesario que ingreses un número de celular válido.',
  ERROR_CELULAR_ANTIFRAUDE: 'Es necesario que ingreses un número de celular válido.',
  ERROR_DNI_NO_VALIDO: 'Es necesario que ingreses un número de DNI válido.',
  ERROR_DNI_VACIO: 'Es necesario que ingreses un número de DNI válido.',
  ERROR_DNI_NO_EXISTE: 'Dni no existe',
  ERROR_CORREO_NO_VALIDO: 'Ingresa un correo válido',
  ERROR_CORREO_VACIO: 'Ingresa un Correo electrónico.',
  ERROR_CORREO_ANTIFRAUDE: 'Ingresa un correo electrónico válido.',
  ERROR_FECHA_NACIMIENTO: 'La fecha de nacimiento que ingresaste no coincide con la de tu DNI o es inválida.',
  ERROR_FECHA_VACIO: 'La fecha de nacimiento que ingresaste no coincide con la de tu DNI o es inválida.',
  ERROR_FECHA_MENOR_DE_EDAD: 'Es necesario tener 18 años para poder continuar.',
  ERROR_FECHA_INCORRECTA: 'La fecha de nacimiento que ingresaste no coincide con la de tu DNI o es inválida.',
};

const VALIDACION_DATA = {
  EDAD_MINIMA: 18,
};

const DivCaptcha = styled.div`
  display: ${pro => pro.visibility};
  @media screen and (-ms-high-contrast: none) {
    width: 100%;
  }
`;

export default PasoInicio;